import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

export const Route = createFileRoute("/(auth)/reset-password")({
  validateSearch: z.object({
    email: z.string().optional(),
  }),
})
